import script from "./TransferNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferNavbar.vue?vue&type=script&setup=true&lang=js"

import "./TransferNavbar.vue?vue&type=style&index=0&id=4bf25074&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf25074"]])

export default __exports__